export const MAX_IMAGE_SIZE_1MB = 1000000;
export const ACCEPTED_FORMATS = { 'image/jpeg': ['.jpeg', '.jpg'], 'image/png': ['.png'] };

//Api timeouts
export const TIMEOUT_NONE = 0;
export const TIMEOUT_LOCALHOST = 5000; //5s
export const TIMEOUT_GLOBAL = 15000; //15s
